export default __webpack_public_path__ + "static/media/README.9465fc39.md";